import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import "./App.scss";
import Header from "./components/header.components";
import Footer from "./components/footer.componets";

import Home from "./pages/home.component";
import Contact from "./pages/contacts.component";
import Disclaimer from "./pages/disclaimer.component";
import ArticleList from "./pages/list.component";
import About from "./pages/about.component";
import Subscribepage from "./pages/subscribepage.component";
import ArticleDetail from "./pages/article.detail.component";
import LatestArticles from "./pages/latest.articles.component";
import PopularArticles from "./pages/popular.articles.component";
import LatestComments from "./pages/latest.comments.component";
import LatestVideos from "./pages/latest.videos.component";
import Privacypolicy from "./pages/privacypolicy.component";
import Advertise from "./pages/advertise.component";
import Donate from "./pages/donate.component";
import http from "./http";
import SideBar from "./components/sidebarInnerPage.component";
import Search from "./pages/search.component";
import ViewComments from "./pages/view.comments.page";
import Archives from "./pages/archives.page.component";
import BestOfBefore from "./pages/bestofbefore.component";
import NotFoundPage from "./pages/notFoundPage";
import UnSubscribepage from "./pages/unsubscribepage.componen";

class App extends React.Component {
  state = {
    writers: []
  };
  getWritersList = async () => {
    try {
      const writers = localStorage.getItem("writers");
      const tx = localStorage.getItem("writersTime");
      const tc = new Date().getTime();
      const diff = Math.abs((parseInt(tc) - parseInt(tx)) / (60 * 60 * 1000));
      if (writers && diff < 8) {
        this.setState({ writers: JSON.parse(writers) });
        return;
      }
      const result = await http.get("/authors");
      localStorage.setItem("writers", JSON.stringify(result.data));
      localStorage.setItem("writersTime", new Date().getTime());
      this.setState({ writers: result.data });
    } catch (err) {}
  };

  componentDidMount() {
    this.getWritersList();
  }

  render() {
    const { location } = this.props;
    return (
      <React.Fragment>
        <Header writers={this.state.writers} />
        <Switch>
          <Route exact path="/" component={Home} />
        </Switch>
        <section className="innerPageWrap pb-5 contactPage">
          <div className="container">
            <div className="row">
              {location.pathname !== "/" ? <SideBar /> : null}
              <Switch>
                <Route path="/contacts" component={Contact} />
                <Route exact path="/disclaimer" component={Disclaimer} />
                <Route exact path="/about" component={About} />
                <Route exact path="/subscribe" component={Subscribepage} />
                <Route exact path="/unsubscribe" component={UnSubscribepage} />
                <Route exact path="/privacypolicy" component={Privacypolicy} />
                <Route exact path="/advertise" component={Advertise} />
                <Route exact path="/donate" component={Donate} />
                <Route exact path="/search" component={Search} />
                <Route
                  exact
                  path="/articles/:articleSlug/:writerId"
                  component={ArticleList}
                />
                <Route
                  exact
                  path="/articles/sections/:articleSlug/:sectionId"
                  component={ArticleList}
                />
                <Route exact path="/bestOfArticles" component={BestOfBefore} />
                <Route
                  exact
                  path="/latestArticles"
                  component={LatestArticles}
                />
                <Route
                  exact
                  path="/popularArticles"
                  component={PopularArticles}
                />
                <Route
                  exact
                  path="/latestComments"
                  component={LatestComments}
                />
                <Route exact path="/latestVideos" component={LatestVideos} />
                <Route
                  exact
                  path="/:sectionName/:articleHeading/d/:articleID"
                  component={ArticleDetail}
                />
                <Route
                  exact
                  path="/:sectionName/:authorName/:articleHeading/d/:articleID"
                  component={ArticleDetail}
                />
                <Route
                  exact
                  path="/viewComments/:articleID"
                  component={ViewComments}
                />
                <Route exact path="/bestArticles" component={Archives} />
                {location.pathname !== "/" ? <Route  component={NotFoundPage} /> : null}
              </Switch>
            </div>
          </div>
        </section>
        <Footer />
      </React.Fragment>
    );
  }
}

export default withRouter(App);
